import {
  MonthViewWrapper,
  MonthHeaderRow,
  MonthHeaderCell,
  MonthGrid,
  MonthCell,
  MonthDay,
  MonthNotificationBadge
} from '../../../Css/StyledCalendarMonth.js';

import {
  getAppointmentsForDate
} from '../../../../utils/calendarUtils.js';

import {
  TURN_TYPES,
  normalizeTurnType
} from '../../../../constants/calendarConstants.js';

const MONTH_DAY_NAMES = ['L', 'M', 'M', 'J', 'V', 'S', 'D'];

const getMonthEventSummary = (appointments = []) => {
  const summary = {
    sesionPaciente: 0,
    reunionPadres: 0,
    reunionColegio: 0,
    reunionProfesionales: 0
  };

  appointments.forEach((appointment) => {
    const tipoTurno = normalizeTurnType(appointment?.tipo_turno);

    if (tipoTurno === TURN_TYPES.SESION_PACIENTE) {
      summary.sesionPaciente += 1;
      return;
    }

    if (tipoTurno === TURN_TYPES.REUNION_PADRES) {
      summary.reunionPadres += 1;
      return;
    }

    if (tipoTurno === TURN_TYPES.REUNION_COLEGIO) {
      summary.reunionColegio += 1;
      return;
    }

    if (tipoTurno === TURN_TYPES.REUNION_PROFESIONALES) {
      summary.reunionProfesionales += 1;
    }
  });

  return summary;
};

const MonthView = ({
  monthDays,
  totalRows,
  highlightDay,
  appointments = [],
  referenceDate = new Date(),
  onDayClick,
}) => {
  const referenceYear = referenceDate.getFullYear();
  const referenceMonth = referenceDate.getMonth();

  return (
    <MonthViewWrapper>
      <MonthHeaderRow>
        {MONTH_DAY_NAMES.map((dayName, index) => (
          <MonthHeaderCell key={`${dayName}-${index}`} isFirst={index === 0}>
            {dayName}
          </MonthHeaderCell>
        ))}
      </MonthHeaderRow>

      <MonthGrid>
        {monthDays.map((day, index) => {
          const cellDate = day
            ? new Date(referenceYear, referenceMonth, day)
            : null;

          const today = new Date();

          const isTodayCell = Boolean(
            cellDate &&
            cellDate.getFullYear() === today.getFullYear() &&
            cellDate.getMonth() === today.getMonth() &&
            cellDate.getDate() === today.getDate()
          );

          const dayAppointments = cellDate
            ? getAppointmentsForDate(appointments, cellDate)
            : [];

          const eventSummary = getMonthEventSummary(dayAppointments);

          return (
            <MonthCell
              key={`month-day-${index}`}
              isPlaceholder={!day}
              onClick={() => {
                if (cellDate && onDayClick) {
                  onDayClick(cellDate);
                }
              }}
              style={{
                cursor: day ? 'pointer' : 'default'
              }}
            >
              {day ? (
                <>
                  <MonthDay active={isTodayCell}>
                    {day}
                  </MonthDay>

                  {eventSummary.sesionPaciente > 0 && (
                    <MonthNotificationBadge
                      position="topLeft"
                      variant="ok"
                      title={`${eventSummary.sesionPaciente} sesión(es) con paciente`}
                    >
                      {eventSummary.sesionPaciente}
                    </MonthNotificationBadge>
                  )}

                  {eventSummary.reunionPadres > 0 && (
                    <MonthNotificationBadge
                      position="topRight"
                      variant="padres"
                      title={`${eventSummary.reunionPadres} reunión(es) con padres`}
                    >
                      {eventSummary.reunionPadres}
                    </MonthNotificationBadge>
                  )}

                  {eventSummary.reunionColegio > 0 && (
                    <MonthNotificationBadge
                      position="bottomLeft"
                      variant="colegio"
                      title={`${eventSummary.reunionColegio} reunión(es) con colegio`}
                    >
                      {eventSummary.reunionColegio}
                    </MonthNotificationBadge>
                  )}

                  {eventSummary.reunionProfesionales > 0 && (
                    <MonthNotificationBadge
                      position="bottomRight"
                      variant="profesionales"
                      title={`${eventSummary.reunionProfesionales} reunión(es) con profesionales`}
                    >
                      {eventSummary.reunionProfesionales}
                    </MonthNotificationBadge>
                  )}
                </>
              ) : null}
            </MonthCell>
          );
        })}
      </MonthGrid>
    </MonthViewWrapper>
  );
};

export default MonthView;